import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  ButtonGroup,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Label,
  Col,
} from "reactstrap";
import Swal from "sweetalert2";
import ExportJsonExcel from "js-export-excel";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import axios from "axios";
import moment from "moment";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

function ListadoAjustesInventario() {
  const { user } = useContext(AuthContext);
  const URL_AJUSTES = process.env.REACT_APP_URL_AJUSTES;
  const URL_ARTICULOS_AJUSTE = process.env.REACT_APP_URL_ARTICULOS_AJUSTE;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 60);
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [comments, setComments] = useState([]);
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(hoy);

  // Modal de detalle
  const [modalDetalle, setModalDetalle] = useState(false);
  const toggleDetalle = () => setModalDetalle(!modalDetalle);
  const [detalle, setDetalle] = useState([]);
  const [tituloDetalle, setTituloDetalle] = useState("");

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_AJUSTES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAjustes = response.data;
        let arrayTabla = allAjustes
          .sort((a, b) => (a.idAjustes < b.idAjustes ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              folio: a.idAjustes,
              fecha: a.fecha,
              area: a.areas[0] ? a.areas[0].name : "",
              motivo: a.motivo,
              usuario: a.user[0]
                ? a.user[0].nombre + " " + a.user[0].apellido
                : "",
              total: a.total,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        setComments(arrayTabla);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  function verDetalle(id, folio) {
    showLoader();
    axios
      .get(`${URL_ARTICULOS_AJUSTE}/ajuste/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setTituloDetalle(`Ajuste #${folio}`);
        setDetalle(response.data);
        hideLoader();
        toggleDetalle();
      })
      .catch((err) => {
        console.log(err);
        hideLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se pudo cargar el detalle!",
        });
      });
  }

  // Comprobante PDF de un ajuste con su detalle
  function PDFAjuste(row) {
    axios
      .get(`${URL_ARTICULOS_AJUSTE}/ajuste/${row._id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        const det = response.data;
        const data = det.map((a) => [
          a.articulos[0]
            ? (a.articulos[0].codigo || "") +
              " " +
              (a.articulos[0].descripcion || "")
            : "",
          a.colores[0] ? a.colores[0].name : "",
          a.tallas[0] ? a.tallas[0].name : "",
          new Intl.NumberFormat("en-US").format(a.cantidadAnterior),
          new Intl.NumberFormat("en-US").format(a.cantidad),
          (a.diferencia > 0 ? "+" : "") +
            new Intl.NumberFormat("en-US").format(a.diferencia),
        ]);

        const doc = new jsPDF();
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        doc.addImage(img, "png", 159, 8, 31, 10);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 15, 12, 45, 18);
        doc.setFontSize(14);
        doc.text(`Ajuste de Inventario #${row.folio}`, 15, 40);
        doc.setFontSize(10);
        doc.text(`Fecha: ${row.fecha}`, 15, 47);
        doc.text(`Almacen: ${row.area}`, 15, 52);
        doc.text(`Usuario: ${row.usuario}`, 15, 57);
        doc.text(`Motivo: ${row.motivo}`, 15, 62);
        doc.autoTable({
          head: [
            [
              "Articulo",
              "Color",
              "Talla",
              "Cant. Anterior",
              "Cant. Nueva",
              "Diferencia",
            ],
          ],
          body: data,
          startY: 70,
        });
        window.open(doc.output("bloburl"), "_blank");
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se pudo generar el PDF!",
        });
      });
  }

  function excel() {
    const dataExcel = commentsData.map((a) => {
      return {
        Folio: a.folio,
        Fecha: a.fecha,
        Area: a.area,
        Motivo: a.motivo,
        Usuario: a.usuario,
        Articulos: a.total,
      };
    });
    const dataExcelLimpia = Object.values(dataExcel).filter((el) => el != null);
    var option = {};
    option.fileName = `AjustesInventario-${selectedFechaInicio}-${selectedFechaFin}`;
    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "Ajustes",
        sheetFilter: ["Folio", "Fecha", "Area", "Motivo", "Usuario", "Articulos"],
        sheetHeader: ["Folio", "Fecha", "Area", "Motivo", "Usuario", "Articulos"],
      },
    ];
    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  const headers = [
    { name: "Folio", field: "folio", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Area", field: "area", sortable: true },
    { name: "Motivo", field: "motivo", sortable: true },
    { name: "Usuario", field: "usuario", sortable: true },
    { name: "Articulos", field: "total", sortable: true },
    { name: "Detalle", field: "detalle", sortable: false },
    { name: "PDF", field: "pdf", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.motivo.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.usuario.toLowerCase().includes(search.toLowerCase()) ||
          comment.fecha.toLowerCase().includes(search.toLowerCase()) ||
          comment.folio.toString().includes(search)
      );
    }

    setTotalItems(computedComments.length);

    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort((a, b) => {
        if (typeof a[sorting.field] === "number") {
          return reversed * (a[sorting.field] - b[sorting.field]);
        }
        return (
          reversed *
          String(a[sorting.field]).localeCompare(String(b[sorting.field]))
        );
      });
    }

    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting]);

  return (
    <>
      <Header />
      <br />
      <br />
      {user.ajusteInventarioUser ? (
        <div className="card container col-11">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuInventarios"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
              <Button
                size="sm"
                href="/AjusteInventarioCreate"
                className="btn btn-success"
              >
                Nuevo Ajuste
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                  disabled={comments.length === 0}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <h3 align="center">Ajustes de Inventario</h3>

          <Row>
            <Col md={3}>
              <Label>Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </Col>
          </Row>
          <br />

          <div className="row">
            <div className="col-md-6">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-6 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>

          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                return (
                  <tr key={a._id}>
                    <td>{a.folio}</td>
                    <td>{a.fecha}</td>
                    <td>{a.area}</td>
                    <td>{a.motivo}</td>
                    <td>{a.usuario}</td>
                    <td>{a.total}</td>
                    <td>
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={() => verDetalle(a._id, a.folio)}
                      >
                        <i class="fas fa-search"></i>
                      </Button>
                    </td>
                    <td>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={() => PDFAjuste(a)}
                      >
                        <i class="fas fa-file-pdf"></i>
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>

          <Modal size="lg" isOpen={modalDetalle} toggle={toggleDetalle}>
            <ModalHeader toggle={toggleDetalle}>
              <h4>{tituloDetalle}</h4>
            </ModalHeader>
            <ModalBody>
              <Table size="sm" striped borderless>
                <thead>
                  <tr>
                    <th>Articulo</th>
                    <th>Color</th>
                    <th>Talla</th>
                    <th>Cant. Anterior</th>
                    <th>Cant. Nueva</th>
                    <th>Diferencia</th>
                  </tr>
                </thead>
                <tbody>
                  {detalle.map((a) => {
                    return (
                      <tr key={a._id}>
                        <td>
                          {a.articulos[0]
                            ? (a.articulos[0].codigo || "") +
                              " " +
                              (a.articulos[0].descripcion || "")
                            : ""}
                        </td>
                        <td>{a.colores[0] ? a.colores[0].name : ""}</td>
                        <td>{a.tallas[0] ? a.tallas[0].name : ""}</td>
                        <td>
                          {new Intl.NumberFormat("en-US").format(
                            a.cantidadAnterior
                          )}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US").format(a.cantidad)}
                        </td>
                        <td
                          style={{
                            color: a.diferencia < 0 ? "#dc3545" : "#198754",
                            fontWeight: 600,
                          }}
                        >
                          {a.diferencia > 0 ? "+" : ""}
                          {new Intl.NumberFormat("en-US").format(a.diferencia)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
      {loader}
    </>
  );
}

export default ListadoAjustesInventario;
